import { Component, ElementRef, Inject, Input, NgZone, PLATFORM_ID, TransferState } from '@angular/core';
import {
  DxButtonComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { AbcTooltipDirective } from '../abc-tooltip.directive';

@Component({
  selector: 'abc-button',
  standalone: true,
  hostDirectives: [{ directive: AbcTooltipDirective }],
  template: '',
  providers: [DxTemplateHost, WatcherHelper, IterableDifferHelper, NestedOptionHost],
})
export class _AbcButtonComponent extends DxButtonComponent {
  private _toolTipContent: string;

  @Input()
  set toolTipContent(value: string) {
    this._toolTipContent = value;

    if (value) {
      this.abcTooltip.elementClassName = `.dx-button-content`;
      this.abcTooltip.toolTipContentTemplate = value;
    }
  }

  get toolTipContent(): string {
    return this._toolTipContent;
  }

  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    watcherHelper: WatcherHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any,
    private abcTooltip: AbcTooltipDirective,
  ) {
    super(elementRef, ngZone, templateHost, watcherHelper, optionHost, transferState, platformId);
  }
}
